(() => {
  const wrap = document.querySelector('[data-load-more-wrap]');
  const grid = document.querySelector('[data-products-grid] .grid');
  if (!wrap || !grid) return;

  const button = wrap.querySelector('[data-load-more]');
  const fallback = wrap.querySelector('[data-load-more-fallback]');
  if (!button) return;

  // JS works: show the button, hide numbered pagination.
  button.hidden = false;
  if (fallback) fallback.hidden = true;

  // Per-URL state (filters/sort are in location.search, so each combination has its own key).
  const KEY = 'mlm:' + location.pathname + location.search;
  let record = null;

  function readRecord() {
    try { return JSON.parse(sessionStorage.getItem(KEY)); } catch (e) { return null; }
  }

  function writeRecord() {
    try {
      if (record) sessionStorage.setItem(KEY, JSON.stringify(record));
      else sessionStorage.removeItem(KEY);
    } catch (e) {}
  }

  function saveScroll() {
    if (!record) return;
    record.y = window.scrollY;
    writeRecord();
  }

  // Same page URL as the current one (keeps filter/sort params), only `page` replaced.
  function pageUrl(page) {
    const u = new URL(location.href);
    u.searchParams.set('page', page);
    return u.pathname + u.search;
  }

  // Server-given next URL, rebuilt on top of the current query string.
  function normalizeNext(url) {
    if (!url) return null;
    const page = new URL(url, location.href).searchParams.get('page');
    return page ? pageUrl(page) : url;
  }

  function itemKey(el) {
    const a = el.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : null;
  }

  const seen = {};
  Array.prototype.forEach.call(grid.children, (el) => {
    const k = itemKey(el);
    if (k) seen[k] = true;
  });

  // Fetch one page, append its items (skipping duplicates), return the next page URL or null.
  async function fetchAndAppend(url) {
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error(response.status);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

    const nextGrid = doc.querySelector('[data-products-grid] .grid');
    if (!nextGrid) throw new Error('grid not found');
    Array.prototype.slice.call(nextGrid.children).forEach((el) => {
      const k = itemKey(el);
      if (k && seen[k]) return;
      if (k) seen[k] = true;
      grid.append(el);
    });

    const nextButton = doc.querySelector('[data-load-more]');
    return normalizeNext(nextButton && nextButton.dataset.nextUrl);
  }

  function setNext(next) {
    if (next) {
      button.dataset.nextUrl = next;
      button.disabled = false;
    } else {
      button.remove();
    }
  }

  function showFallback() {
    button.hidden = true;
    if (fallback) fallback.hidden = false;
  }

  button.addEventListener('click', async () => {
    const url = button.dataset.nextUrl;
    if (!url || button.disabled) return;
    button.disabled = true;

    try {
      const next = await fetchAndAppend(url);
      record = { next: next, loaded: (record ? record.loaded : 0) + 1, y: 0 };
      writeRecord();
      setNext(next);
    } catch (error) {
      // Fall back to normal pagination links.
      showFallback();
    }
  });

  // Remember scroll position when leaving the page.
  window.addEventListener('pagehide', saveScroll);
  grid.addEventListener('click', (event) => {
    if (event.target.closest && event.target.closest('a[href*="/products/"]')) saveScroll();
  });

  // Restore on Back / reload: re-fetch the extra pages, then scroll back.
  const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  const restorable = nav && (nav.type === 'back_forward' || nav.type === 'reload');
  const saved = readRecord();

  if (!saved || !saved.loaded || !restorable) {
    if (saved) writeRecord(); // fresh visit: drop the stale record (record is still null)
    return;
  }

  const prevRestoration = history.scrollRestoration;
  history.scrollRestoration = 'manual';
  button.disabled = true;

  (async () => {
    record = { next: null, loaded: 0, y: saved.y || 0 };
    const start = parseInt(new URL(location.href).searchParams.get('page'), 10) || 1;
    let next = button.dataset.nextUrl;
    try {
      for (let i = 1; i <= saved.loaded; i++) {
        next = await fetchAndAppend(pageUrl(start + i));
        record.loaded = i;
        record.next = next;
      }
    } catch (error) {
      // Keep whatever loaded; the button continues from the last good page.
      next = record.loaded ? record.next : normalizeNext(button.dataset.nextUrl);
      if (!record.loaded) record = null;
    }
    writeRecord();
    setNext(next);
    window.scrollTo(0, saved.y || 0);
    history.scrollRestoration = prevRestoration;
  })();
})();
